export type ThemeMode = 'light' | 'dark' | 'system';

export const THEME_STORAGE_KEY = 'hai_theme_mode';

const isBrowser = typeof window !== 'undefined';

export function getStoredTheme(): ThemeMode {
  if (!isBrowser) return 'system';
  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored;
  }
  return 'system';
}

export function applyTheme(mode: ThemeMode) {
  if (!isBrowser) return;
  const root = document.documentElement;
  const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  const shouldUseDark = mode === 'dark' || (mode === 'system' && prefersDark);
  root.classList.toggle('dark', shouldUseDark);
  root.dataset.theme = mode;
}

export function setTheme(mode: ThemeMode) {
  if (isBrowser) {
    window.localStorage.setItem(THEME_STORAGE_KEY, mode);
  }
  applyTheme(mode);
}

export function watchSystemTheme(onChange: () => void) {
  if (!isBrowser || !window.matchMedia) return () => {};
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = () => onChange();
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }
  media.addListener(handler);
  return () => media.removeListener(handler);
}
